<template>
  <div class="card-body p-xl-40">
    <h6 class="card-title fw-semiBold fs-18 mb-30">{{ $t("dashboard_page.stock_alert") }}</h6>
    <div v-if="isLoading" class="text-center py-4">
      <span>{{ $t("loading") }}</span>
    </div>
    <div v-else class="table-responsive style-five">
      <table class="table text-nowrap align-middle mb-0">
        <thead>
          <tr>
            <th scope="col" class="text-title fw-normal fs-14 pt-0 ps-0">
              {{ $t("dashboard_page.code") }}
            </th>
            <th scope="col" class="text-title fw-normal fs-14 pt-0">{{ $t("dashboard_page.product") }}</th>
            <th scope="col" class="text-title fw-normal fs-14 pt-0">
              {{ $t("dashboard_page.warehouse") }}
            </th>
            <th scope="col" class="text-title fw-normal fs-14 pt-0">
              {{ $t("dashboard_page.quantity") }}
            </th>
            <th scope="col" class="text-title fw-normal fs-14 pt-0 pe-0">
              {{ $t("dashboard_page.alert_quantity") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in stockAlerts" :key="index">
            <td class="shadow-none fw-normal text-black title ps-0">
              <span class="text-optional fs-14">{{ item.SKU }}</span>
            </td>
            <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
              {{ item.product_name }}
            </td>
            <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
              {{ item.warehouse_name || $t("dashboard_page.not_available") }}
            </td>
            <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
              {{ item.quantity }}
            </td>
            <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
              <span class="text-red fw-bold">{{ item.stock_alert }}</span>
            </td>
          </tr>
          <tr v-if="stockAlerts.length === 0">
            <td colspan="5" class="text-center py-4 text-muted">{{ $t("dashboard_page.no_stock_alerts") }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { DashboardStockAlertItem } from "@/services/dashboard";

export default defineComponent({
  name: "StockAlert",
  props: {
    items: {
      type: Array as () => DashboardStockAlertItem[],
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return {
      stockAlerts: props.items,
    };
  },
});
</script>
